<template>
  <div>
    <v-dialog class="import-se-dialog" :title="dialogTitle" width="auto" :visible.sync="dialogVisible" :z-index="2000" :scrollbar="false" @closed="onClosed">
      <div class="padding-lr">
        <div class="form">
          <el-form :model="form" class="search-input" label-width="80px">
            <el-form-item label="HCPID:" prop="hcpId">
              <el-input placeholder="Input HCP Number" v-model="form.hcpId" clearable @keydown.native.enter="onSearch">
                <template slot="prepend">CN-</template>
                <template slot="append">HCP</template>
              </el-input>
            </el-form-item>
            <el-form-item required label="Name:" :show-message="false" prop="fullName">
              <el-input prefix-icon="el-icon-search" placeholder="Input name" v-model.trim="form.fullName" clearable
                @keydown.native.enter="onSearch">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :disabled="searchDisabled" class="search-btn" @click="onSearch">
                Search
              </el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-alert type="info" show-icon :closable="false">
          <div class="tips">
            <p>
              1. Please import HCP from the source tagged eAuthorship in
              priority.
            </p>
            <p>
              2. If there is no available doctor who you are looking for, please
              follow the existing process to create doctor in Veeva CRM and HCP
              information will be refreshed in eMSL
              <span class="white-spce">soon.</span>
            </p>
            <p v-show="role == roleCode">
              3. If there is no available customer (non-doctor) who you are
              looking for, please click
              <el-button type="text" class="btn-link sqBtn" :disabled="isCreateNewDisable || role != roleCode"
                @click="handleNewSE(),type='here'">here
              </el-button>
              to create new one.
            </p>
          </div>
        </el-alert>
        <el-table :data="tableData" height="36vh" max-height="47.05vh" ref="singleTable"
          @current-change="handleCurrentSelectChange" v-loading="tableLoading" element-loading-text="Loading...">
          <el-table-column label width="30">
            <template slot-scope="{ row }">
              <el-radio :label="row" v-model="selection"><i></i></el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="Name" width="80" />
          <el-table-column prop="province" label="Province" width="120" />
          <el-table-column prop="city" label="City" width="120" />
          <el-table-column prop="hospital" label="Hospital / Institution" min-width="200" />
          <el-table-column prop="department" label="Department" min-width="130" />
          <el-table-column prop="source" label="Source" width="100">
            <template slot-scope="{ row }">
              <el-tag type="success" v-if="row.source === 'EA'">
                eAuthorship</el-tag>
              <el-tag type="warning" v-else>CMDS</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="hcpId" label="HCPID" width="100" />
          <el-table-column label="Operation" align="center" width="110">
            <template slot-scope="{ row }">
              <div class="cell-import">
                <el-button v-if="row === selection" class="cell-import-btn" plain :loading="importing"
                  @click="onImport">
                  Import
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wrap" v-if="total > 10">
          <div class="actions">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage" :page-sizes="[10, 25, 50, 100]" :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="total" />
          </div>
        </div>
      </div>
    </v-dialog>
    <NewSEDialog :visible.sync="newSEDialogVisible" :data.sync="selectSE" @closed="onNewSEClosed" :type="type"/>
  </div>
</template>
<script>
import NewSEDialog from "./new-se-dialog";
import { RoleCode } from "@/utils/role-constant";
export default {
  name: "import-se-dialog",
  components: { NewSEDialog },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      form: { hcpId: "", fullName: "" },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: this.visible,
      originalTableData: [],
      tableLoading: false,
      importing: false,
      selection: null,
      selectSE: null,
      isCreateNewDisable: true,
      newSEDialogVisible: false,
      roleCode: RoleCode.Admin,
      type:''
    };
  },
  computed: {
    searchDisabled() {
      return this.form.fullName.trim().length === 0;
    },
    role() {
      return this.$store.state.role;
    },
    dialogTitle() {
      let title = 'Import New HCP'
      if(this.role==RoleCode.Admin){
        title = 'Import / Create New HCP'
      }
      if(this.role==RoleCode.VMSL){
        title = 'Import New vCE'
      }
      return title
    },
    tableData() {
      const begin = (this.currentPage - 1) * this.pageSize;
      const end = this.currentPage * this.pageSize;
      return this.originalTableData.slice(begin, end);
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
    dialogVisible(value) {
      this.$emit("update:visible", value);
    },
  },
  methods: {
    onClosed() {
      if (!this.newSEDialogVisible) {
        this.form = { hcpId: "", fullName: "" };
        this.currentPage = 1;
        this.pageSize = 10;
        this.total = 0;
        this.originalTableData = [];
        this.selection = null;
        this.isCreateNewDisable = true;
      }
    },
    onSearch() {
      if (this.searchDisabled) {
        return;
      }
      this.selection = null;
      this.tableLoading = true;
      this.axios
        .get("/se/hcp", {
          params: {
            fullName: this.form.fullName.trim(),
            hcpId: this.form.hcpId.trim(),
          },
        })
        .then(({ code, data, msg }) => {
          this.tableLoading = false;
          this.isCreateNewDisable = false;
          if (200 === code) {
            this.clearSelection();
            const { list, total } = data;
            this.currentPage = 1;
            this.pageSize = 10;
            this.originalTableData = list.filter((item) => {
              if (item) {
                return item;
              }
            });
            console.log(this.originalTableData);
            this.total = total;
          } else {
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.tableLoading = false;
          this.isCreateNewDisable = false;
        });
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.clearSelection();
    },
    handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.clearSelection();
    },
    handleCurrentSelectChange(val) {
      this.selection = val;
    },
    clearSelection() {
      this.selection = null;
      this.$refs.singleTable.clearSelection();
    },
    existingSEinEA() {
      this.$confirm(
        "This HCP is existing in eAuthorship, are you sure to continue importing via CMDS. Or click cancel and select the HCP tagged eAuthorship source to import.",
        {
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          callback: (action) => {
            if ("confirm" === action) {
              this.selectSE = Object.assign({}, this.selection);
              this.handleNewSE();
            }
          },
        }
      );
    },
    async onImport() {
      const { source } = this.selection;
      this.importing = true;
      await this.axios.get(`/se/hcpInfo?hcpId=${this.selection.hcpId}`)
        .then(({ code, data }) => {
          this.importing = false;
          if (200 === code) {
            this.selection= {...this.selection,...data}
            console.log('after hcpinfo api:',this.selection)
          }
        })
      if (source === "EA") {
        this.selectSE = Object.assign({}, this.selection);
        this.handleNewSE();
        return;
      }

      this.importing = true;
      this.axios
        .get("/se/checkSeValid", { params: this.selection })
        .then(({ code, msg }) => {
          this.importing = false;
          if (200 === code) {
            if (source === "CMDS") {
              const EAdata = this.originalTableData.find((item) => {
                return item.source == "EA";
              });
              if (EAdata && this.selection.hcpId == EAdata.hcpId) {
                this.existingSEinEA();
                return;
              }
            }
            this.selectSE = Object.assign({}, this.selection);
            this.handleNewSE();
          } else if (202 === code) {
            this.existingSEinEA();
          } else {
            this.$alert(msg, {
              type: "warning",
              confirmButtonText: "OK",
              callback: () => { },
            });
          }
        })
        .catch(() => {
          this.importing = false;
        });
    },
    handleNewSE() {
      this.newSEDialogVisible = true;
      this.dialogVisible = false;
    },
    onNewSEClosed(successful) {
      this.type = ''
      this.dialogVisible = !successful;
      if (successful) {
        this.onClosed();
        this.$emit("success");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.import-se-dialog {
  ::v-deep {
    .padding-lr {
      width: 100%;
    }

    .el-table {
      margin-top: 10px;
    }

    .el-dialog__body {
      display: flex;
      max-height: 70vh;
      padding: 10px 20px 15px;
    }

    .el-dialog__footer {
      padding: 0;
    }

    .el-table__row {
      cursor: pointer;
    }
  }
}

.form {
  widows: 100%;
  display: flex;
  justify-content: center;
}

.search-input {
  margin-bottom: 20px;
  display: flex;
}

.cell-import {
  position: relative;
  width: 100%;
  height: 28px;
  text-align: right;

  .cell-import-btn {
    color: #0078a3;
    background: #e6f2f6;
    border-color: #99c9da;

    &:hover,
    &:focus {
      background: #28a8d6;
      border-color: #28a8d6;
      color: #ffffff;
    }
  }
}

.el-alert {
  padding: 0 16px;
}

.tips {
  padding: 10px 0;

  p.row {
    margin-top: 7px;
  }

  .btn-link {
    color: #d52b1e !important;
    font-size: 14px !important;
    font-weight: bold !important;
    text-decoration: underline;
    margin: 0;
    padding: 0;

    &.is-disabled {
      color: #ea958f !important;
    }
  }
}

.white-spce {
  white-space: nowrap;
}
</style>
